// PerformanceService.ts

export interface PerformanceData {
    employeeId: string;
    activityTracking: number;
    timeliness: number;
    responsiveness: number;
    caseload: number;
    personCentered: number;
    adminRequests: number;
    responsivenessRating: string;
    activityTrackingRating: string;
    caseloadRating: string;
    adminRequestsRating: string;
    timelinessRating: string;
    personCenteredRating: string;
}

export async function getUserPerformance(
    employeeId: string,
    authToken: string
): Promise<PerformanceData | null> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/Authentication/${employeeId}/UserPerformance`;

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        if (response.ok) {
            const data: PerformanceData = await response.json();
            return data;
        } else {
            console.error("Error fetching performance data:", response.statusText);
            return null;
        }
    } catch (error) {
        console.error("Error fetching performance data:", error);
        return null;
    }
}